// source: https://github.com/ianstormtaylor/slate/blob/master/site/examples/paste-html.tsx
import { Transforms } from 'slate';
import { jsx } from 'slate-hyperscript';

import { DEFINITIONS as BOLD_DEFINITIONS } from '@xing-com/content-editor-plugin-bold';
import { DEFINITIONS as ITALIC_DEFINITIONS } from '@xing-com/content-editor-plugin-italic';
import { DEFINITIONS as LINK_DEFINITIONS } from '@xing-com/content-editor-plugin-link';
import { DEFINITIONS as PARAGRAPH_DEFINITIONS } from '@xing-com/content-editor-plugin-paragraph';

const linkSerializer = (el) => ({
  type: LINK_DEFINITIONS.type,
  data: {
    href: el?.getAttribute('href') || '',
  },
});
const paragraphDeserializer = () => ({ type: PARAGRAPH_DEFINITIONS.type });

const ELEMENT_TAGS = {
  A: linkSerializer,
  P: paragraphDeserializer,
  // for now make everything else a paragraph
  BLOCKQUOTE: paragraphDeserializer,
  H1: paragraphDeserializer,
  H2: paragraphDeserializer,
  H3: paragraphDeserializer,
  H4: paragraphDeserializer,
  H5: paragraphDeserializer,
  H6: paragraphDeserializer,
  LI: paragraphDeserializer,
};

// COMPAT: `B` is omitted here because Google Docs uses `<b>` in weird ways.
const TEXT_TAGS = {
  EM: () => ({ [ITALIC_DEFINITIONS.type]: true }),
  I: () => ({ [ITALIC_DEFINITIONS.type]: true }),
  STRONG: () => ({ [BOLD_DEFINITIONS.type]: true }),
};

const deserialize = (el) => {
  if (el.nodeType === 3) {
    return el.textContent;
  } else if (el.nodeType !== 1) {
    return null;
  }
  // currently we don't support <br/> on the editor
  // else if (el.nodeName === 'BR') {
  //   return '\n';
  // }

  const { nodeName } = el;
  let parent = el;

  const children = Array.from(parent.childNodes).map(deserialize).flat();

  if (el.nodeName === 'BODY') {
    return jsx('fragment', {}, children);
  }

  if (ELEMENT_TAGS[nodeName]) {
    const attrs = ELEMENT_TAGS[nodeName](el);
    return jsx('element', attrs, children);
  }

  if (TEXT_TAGS[nodeName]) {
    const attrs = TEXT_TAGS[nodeName](el);
    return children.map((child) => jsx('text', attrs, child));
  }

  return children;
};

const withPastedHTML = (editor) => {
  const { insertData } = editor;

  editor.insertData = (data) => {
    // try to read copied text as html
    const html = data.getData('text/html');

    if (html) {
      /* eslint-env browser */
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fragment = deserialize(parsed.body);
      Transforms.insertFragment(editor, fragment);
      return;
    }

    insertData(data);
  };

  return editor;
};

export { withPastedHTML };
